// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes avMode__switch__background__off {
  from {
    background-color: white;
  }
  to {
    background-color: #7cffb7;
  }
}
@keyframes avMode__switch__background__on {
  from {
    background-color: #7cffb7;
  }
  to {
    background-color: white;
  }
}
@keyframes avMode__switch__circle-transition__off {
  from {
    left: calc(100% - 28px);
  }
  to {
    left: 0;
  }
}
@keyframes avMode__switch__circle-transition__on {
  from {
    left: 0;
  }
  to {
    left: calc(100% - 28px);
  }
}
.header .header__row-segment .header__av-mode-switch {
  cursor: pointer;
  position: relative;
  width: 69px;
  height: 28px;
  background-color: #7cffb7;
  border-radius: 58px;
}
.header .header__row-segment .header__av-mode-switch.av-mode-switch__off {
  animation: 1.2s avMode__switch__background__off forwards;
}
.header .header__row-segment .header__av-mode-switch.av-mode-switch__off > .av-mode-switch__inner-top-circle {
  animation: 0.2s avMode__switch__circle-transition__off forwards;
}
.header .header__row-segment .header__av-mode-switch.av-mode-switch__on {
  animation: 1.2s avMode__switch__background__on forwards;
}
.header .header__row-segment .header__av-mode-switch.av-mode-switch__on > .av-mode-switch__inner-top-circle {
  animation: 0.2s avMode__switch__circle-transition__on forwards;
}
.header .header__row-segment .header__av-mode-switch .av-mode-switch__inner-top-circle {
  position: absolute;
  left: 0;
  background: #000;
  border-radius: 14px;
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header .header__row-segment .header__av-mode-switch .av-mode-switch__inner-top-circle .av-mode-switch__inner-dashed-circle {
  width: 18px;
  height: 19px;
  border-radius: 9px;
  border-style: dotted;
  border-width: 2px;
  border-color: #7cffb7;
  display: flex;
  justify-content: center;
  align-items: center;
}
.header .header__row-segment .header__av-mode-switch .av-mode-switch__inner-top-circle .av-mode-switch__inner-dashed-circle .av-mode-switch__inner-dot {
  width: 6px;
  height: 6px;
  margin-top: 0.8px;
  border-radius: 3px;
  background-color: #7cffb7;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/always-visible-mode/av-mode__switch.scss","webpack://./src/Common/components/shared.bundle/always-visible-mode/av-mode__vars.scss"],"names":[],"mappings":"AAEA;EACE;IACE,uBCC4B;EDF9B;EAIA;IACE,yBCJ6B;EDE/B;AACF;AAKA;EACE;IACE,yBCV6B;EDO/B;EAMA;IACE,uBCb4B;EDS9B;AACF;AAOA;EACE;IACE,uBAAA;EALF;EAQA;IACE,OAAA;EANF;AACF;AASA;EACE;IACE,OAAA;EAPF;EAUA;IACE,uBAAA;EARF;AACF;AAcI;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBC9C2B;ED+C3B,mBAAA;AAZN;AAcM;EACE,wDAAA;AAZR;AAcQ;EACE,+DAAA;AAZV;AAgBM;EACE,uDAAA;AAdR;AAgBQ;EACE,8DAAA;AAdV;AAkBM;EACE,kBAAA;EACA,OAAA;EACA,gBAAA;EACA,mBAAA;EACA,WCpEqB;EDqErB,YCrEqB;EDsErB,aAAA;EACA,uBAAA;EACA,mBAAA;AAhBR;AAkBQ;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,qBCpFc;EDqFd,aAAA;EACA,uBAAA;EACA,mBAAA;AAhBV;AAkBU;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBC9FY;AD8ExB","sourcesContent":["@use './av-mode__vars.scss' as *;\n\n@keyframes avMode__switch__background__off {\n  from {\n    background-color: $av-mode-switch--background-on;\n  }\n\n  to {\n    background-color: $av-mode-switch--background-off;\n  }\n}\n\n@keyframes avMode__switch__background__on {\n  from {\n    background-color: $av-mode-switch--background-off;\n  }\n\n  to {\n    background-color: $av-mode-switch--background-on;\n  }\n}\n\n@keyframes avMode__switch__circle-transition__off {\n  from {\n    left: calc(100% - $av-mode-switch--cicle-size);\n  }\n\n  to {\n    left: 0;\n  }\n}\n\n@keyframes avMode__switch__circle-transition__on {\n  from {\n    left: 0;\n  }\n\n  to {\n    left: calc(100% - $av-mode-switch--cicle-size);\n  }\n}\n\n// av-mode switch button\n.header {\n  .header__row-segment {\n    .header__av-mode-switch {\n      cursor: pointer;\n      position: relative;\n      width: 69px;\n      height: 28px;\n      background-color: $av-mode-switch--background-off;\n      border-radius: 58px;\n\n      &.av-mode-switch__off {\n        animation: $animation-duration avMode__switch__background__off forwards;\n\n        > .av-mode-switch__inner-top-circle {\n          animation: $av-mode-switch--cicle-animation-duration avMode__switch__circle-transition__off forwards;\n        }\n      }\n\n      &.av-mode-switch__on {\n        animation: $animation-duration avMode__switch__background__on forwards;\n        \n        > .av-mode-switch__inner-top-circle {\n          animation: $av-mode-switch--cicle-animation-duration avMode__switch__circle-transition__on forwards;\n        }\n      }\n\n      .av-mode-switch__inner-top-circle {\n        position: absolute;\n        left: 0;\n        background: #000;\n        border-radius: calc($av-mode-switch--cicle-size / 2);\n        width: $av-mode-switch--cicle-size;\n        height: $av-mode-switch--cicle-size;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .av-mode-switch__inner-dashed-circle {\n          width: 18px;\n          height: 19px;\n          border-radius: 9px;\n          border-style: dotted;\n          border-width: 2px;\n          border-color: $av-mode-switch--color;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          \n          .av-mode-switch__inner-dot {\n            width: 6px;\n            height: 6px;\n            margin-top: 0.8px;\n            border-radius: 3px;\n            background-color: $av-mode-switch--color;\n          }\n        }\n      }\n    }\n  }\n}","$animation-duration: 1.2s;\n\n$av-mode-switch--color: #7cffb7; \n$av-mode-switch--cicle-animation-duration: 0.2s;\n$av-mode-switch--background-off: #7cffb7; \n$av-mode-switch--background-on: white; \n$av-mode-switch--cicle-size: 28px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
